(() => {
  const VERSION = '2026.09.05.12';

  if (window.BHProductReviews?.version === VERSION) return;

  const translations = new Map([
    ['Customer Reviews', 'Opiniones de nuestros clientes'],
    ['Write a review', 'Escribir una opinión'],
    ['Write A Review', 'Escribir una opinión'],
    ['Most Recent', 'Más recientes'],
    ['Highest Rating', 'Mejor puntuación'],
    ['Lowest Rating', 'Menor puntuación'],
    ['Most Helpful', 'Más útiles'],
    ['With Pictures', 'Con fotos'],
    ['Submit Review', 'Publicar opinión'],
    ['Cancel Review', 'Cancelar'],
    ['Review', 'Opinión'],
    ['Reviews', 'Opiniones'],
    ['Verified Buyer', 'Compra verificada'],
    ['Verified Purchase', 'Compra verificada'],
    ['Sort by', 'Ordenar por'],
    ['Pictures', 'Fotos'],
    ['See more', 'Ver más'],
    ['See less', 'Ver menos'],
    ['Was this review helpful?', '¿Te resultó útil esta opinión?'],
    ['Helpful', 'Útil'],
    ['Yes', 'Sí'],
    ['No', 'No'],
    ['No reviews yet', 'Aún no hay opiniones'],
    ['Be the first to write a review', 'Sé la primera persona en compartir su experiencia']
  ]);

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const reviewKeywordRules = [
    ['impermeable', /impermeabl|antifluido/iu],
    ['excelente calidad', /excelente|calidad/iu],
    ['cumple con las expectativas', /expectativ|recomiend|cumpl/iu],
    ['suave', /suav/iu],
    ['abrigador', /abrig/iu],
    ['buen tamaño', /tamaño|medida/iu]
  ];

  const translateValue = (value) => {
    const clean = normalize(value);
    if (!clean) return null;
    if (translations.has(clean)) return translations.get(clean);

    let match = clean.match(/^Based on (\d+) reviews?$/i);
    if (match) return Number(match[1]) === 1 ? 'Basado en 1 opinión' : `Basado en ${match[1]} opiniones`;

    match = clean.match(/^(\d+) reviews?$/i);
    if (match) return Number(match[1]) === 1 ? '1 opinión' : `${match[1]} opiniones`;

    return null;
  };

  const translateTextNodes = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, textarea')) return NodeFilter.FILTER_REJECT;
        return translateValue(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const translated = translateValue(node.nodeValue);
      if (translated) node.nodeValue = translated;
    });
  };

  const translateAttributes = (root) => {
    root.querySelectorAll('[aria-label], [placeholder], [title]').forEach((element) => {
      ['aria-label', 'placeholder', 'title'].forEach((attribute) => {
        const translated = translateValue(element.getAttribute(attribute));
        if (translated) element.setAttribute(attribute, translated);
      });
    });
  };

  const removeReviewVerificationMarks = (review) => {
    review.classList.remove('has-verified-review');

    const badgeSelector = [
      '[data-verified-buyer]',
      '[data-verified-review]',
      '[class*="buyer-badge"]',
      '[class*="verified-badge"]',
      '[class*="rev__badge"]',
      '[class*="checkmark"]',
      '[class*="check-mark"]',
      '[class*="jdgm-check"]',
      '[title*="verified" i]',
      '[aria-label*="verified" i]',
      '[title*="verificada" i]',
      '[aria-label*="verificada" i]'
    ].join(',');

    review.querySelectorAll(badgeSelector).forEach((badge) => badge.remove());
    review.querySelectorAll('span, i, b, em').forEach((node) => {
      if (node.closest('.jdgm-rev__rating')) return;
      if (node.children.length === 0 && /^(✓|✔|☑)$/u.test(normalize(node.textContent))) node.remove();
    });
  };

  const enhanceAccessibility = (root) => {
    root.querySelectorAll('.jdgm-rev').forEach((review) => {
      review.setAttribute('role', 'article');
      review.classList.toggle(
        'has-review-media',
        Boolean(review.querySelector('.jdgm-rev__pics, .jdgm-rev__pic-link, .jdgm-rev__video'))
      );

      review.querySelectorAll('.bh-review-avatar').forEach((avatar) => avatar.remove());
      removeReviewVerificationMarks(review);

      const header = review.querySelector('.jdgm-rev__header');
      if (!header) return;

      let meta = header.querySelector(':scope > .bh-review-meta');
      if (!meta) {
        meta = document.createElement('div');
        meta.className = 'bh-review-meta';
        header.prepend(meta);
      }

      const icon = header.querySelector('.jdgm-rev__icon');
      const rating = header.querySelector('.jdgm-rev__rating');
      const authorWrapper = header.querySelector('.jdgm-rev__author-wrapper');
      const author = header.querySelector('.jdgm-rev__author');
      const timestamp = header.querySelector('.jdgm-rev__timestamp');
      [icon, rating, authorWrapper || author, timestamp].forEach((item) => {
        if (item && item.parentElement !== meta) meta.append(item);
      });

      if (icon) {
        icon.querySelectorAll(':scope > :not(.bh-review-avatar-icon)').forEach((node) => node.remove());
        const avatars = icon.querySelectorAll(':scope > .bh-review-avatar-icon');
        avatars.forEach((avatar, index) => {
          if (index > 0) avatar.remove();
        });
        if (!avatars.length) {
          icon.insertAdjacentHTML(
            'afterbegin',
            '<svg class="bh-review-avatar-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.25"></circle><path d="M5.75 20v-2.1A6.25 6.25 0 0 1 12 11.65a6.25 6.25 0 0 1 6.25 6.25V20"></path></svg>'
          );
        }
        icon.dataset.bhAvatarReady = 'true';
      }

      let purchase = review.querySelector('.bh-review-purchase');
      if (!purchase) {
        purchase = document.createElement('div');
        purchase.className = 'bh-review-purchase';
      }

      const customDetails = [...review.querySelectorAll('.jdgm-rev__custom-form, .jdgm-rev__cf-answers')]
        .filter((node, _index, nodes) => {
          if (node.closest('.bh-review-purchase')) return false;
          return !nodes.some((candidate) => candidate !== node && candidate.contains(node));
        });
      if (customDetails.length) {
        purchase.dataset.variantText = customDetails
          .map((node) => normalize(node.textContent))
          .filter(Boolean)
          .join(' · ');
        customDetails.forEach((node) => node.remove());
      }

      const purchasedLabel = normalize(root.dataset.productPurchasedLabel) || 'Compró';
      const productTitle = normalize(root.dataset.productTitle) || 'este producto';
      const variantText = normalize(purchase.dataset.variantText);
      purchase.textContent = `${purchasedLabel} ${productTitle}${variantText ? ` · ${variantText}` : ''}`;
      meta.append(purchase);

      removeReviewVerificationMarks(review);
    });

    root.querySelectorAll('.jdgm-rev__pic-link').forEach((link) => {
      if (!link.getAttribute('aria-label')) link.setAttribute('aria-label', 'Abrir foto de la opinión');
    });
  };

  const getImageSource = (image) =>
    image?.currentSrc || image?.getAttribute('data-src') || image?.getAttribute('data-original') || image?.src || '';

  const formatReviewDate = (value) => {
    const match = normalize(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[2]}/${match[3]}/${match[1]}` : normalize(value);
  };

  const readReview = (mediaElement) => {
    const review = mediaElement.closest('.jdgm-rev');
    if (!review) return null;
    const image = mediaElement.matches('img') ? mediaElement : mediaElement.querySelector('img');
    const link = mediaElement.matches('a') ? mediaElement : mediaElement.closest('a');
    const source = link?.getAttribute('data-mfp-src') || link?.href || getImageSource(image);
    if (!source) return null;

    const ratingElement = review.querySelector('.jdgm-rev__rating');
    const score = Math.max(0, Math.min(5, Number(ratingElement?.dataset.score) || 5));

    return {
      source,
      alt: image?.alt || 'Foto de una reseña',
      author: normalize(review.querySelector('.jdgm-rev__author')?.textContent) || 'Cliente',
      date:
        normalize(review.querySelector('.jdgm-rev__timestamp')?.textContent) ||
        formatReviewDate(review.querySelector('.jdgm-rev__timestamp')?.getAttribute('data-content')),
      comment: normalize(review.querySelector('.jdgm-rev__body')?.textContent),
      rating: `${'★'.repeat(score)}${'☆'.repeat(5 - score)}`
    };
  };

  const collectReviewMedia = (root) => {
    const records = [];
    const seen = new Set();
    root.querySelectorAll('.jdgm-rev__pic-link, .jdgm-rev__pic-img').forEach((element) => {
      const record = readReview(element);
      if (!record || seen.has(record.source)) return;
      seen.add(record.source);
      records.push(record);
    });
    return records;
  };

  const mergeReviewMedia = (...groups) => {
    const records = [];
    const seen = new Set();
    groups.flat().forEach((record) => {
      if (!record?.source || seen.has(record.source)) return;
      seen.add(record.source);
      records.push(record);
    });
    return records;
  };

  const countReviewKeywords = (root) => {
    const counts = Object.fromEntries(reviewKeywordRules.map(([label]) => [label, 0]));
    root.querySelectorAll('.jdgm-rev__body').forEach((body) => {
      const text = normalize(body.textContent);
      reviewKeywordRules.forEach(([label, pattern]) => {
        if (pattern.test(text)) counts[label] += 1;
      });
    });
    return counts;
  };

  const mergeKeywordCounts = (...groups) => {
    const counts = {};
    groups.forEach((group) => {
      Object.entries(group || {}).forEach(([label, count]) => {
        counts[label] = (counts[label] || 0) + count;
      });
    });
    return counts;
  };

  const buildReviewKeywords = (section, counts) => {
    const container = section.querySelector('[data-bh-review-keywords]');
    if (!container) return;
    const keywords = Object.entries(counts || {})
      .filter(([, count]) => count > 0)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 3);
    container.replaceChildren();
    keywords.forEach(([label, count]) => {
      const chip = document.createElement('span');
      chip.className = 'bh-review-keywords__item';
      chip.textContent = `${label} (${count})`;
      container.append(chip);
    });
    container.hidden = keywords.length === 0;
  };

  const fetchReviewPage = async (productId, shopDomain, page) => {
    const url = new URL('https://api.judge.me/reviews/reviews_for_widget');
    url.search = new URLSearchParams({
      product_id: productId,
      shop_domain: shopDomain,
      platform: 'shopify',
      page: String(page),
      per_page: '30'
    });
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Judge.me respondió ${response.status}`);
    const payload = await response.json();
    const parsed = new DOMParser().parseFromString(payload.html || '', 'text/html');
    return {
      records: collectReviewMedia(parsed),
      keywordCounts: countReviewKeywords(parsed),
      reviewCount: parsed.querySelectorAll('.jdgm-rev').length,
      totalCount: Number(payload.total_count) || 0
    };
  };

  const loadAllReviewMedia = async (section) => {
    if (section._bhReviewMediaPromise) return section._bhReviewMediaPromise;
    const productId = normalize(section.dataset.productId);
    const shopDomain = normalize(window.Shopify?.shop);
    if (!productId || !shopDomain) return [];

    section._bhReviewMediaPromise = (async () => {
      try {
        const firstPage = await fetchReviewPage(productId, shopDomain, 1);
        const perPage = Math.max(1, firstPage.reviewCount);
        const totalPages = Math.max(1, Math.ceil(firstPage.totalCount / perPage));
        const records = [...firstPage.records];
        let keywordCounts = firstPage.keywordCounts;

        for (let page = 2; page <= totalPages; page += 4) {
          const pageNumbers = Array.from(
            { length: Math.min(4, totalPages - page + 1) },
            (_, index) => page + index
          );
          const responses = await Promise.all(pageNumbers.map((pageNumber) => fetchReviewPage(productId, shopDomain, pageNumber)));
          responses.forEach((response) => {
            records.push(...response.records);
            keywordCounts = mergeKeywordCounts(keywordCounts, response.keywordCounts);
          });
        }

        section._bhRemoteReviewMedia = mergeReviewMedia(records);
        section._bhReviewKeywordCounts = keywordCounts;
        buildReviewKeywords(section, keywordCounts);
        buildReviewGallery(section);
        return section._bhRemoteReviewMedia;
      } catch (error) {
        console.warn('[BH Reviews] No se pudo precargar la galería completa.', error);
        return [];
      }
    })();

    return section._bhReviewMediaPromise;
  };

  const setupLightbox = (section, records) => {
    const dialog = section.querySelector('[data-bh-review-lightbox]');
    if (!dialog) return;
    const image = dialog.querySelector('[data-bh-review-lightbox-image]');
    const author = dialog.querySelector('[data-bh-review-lightbox-author]');
    const date = dialog.querySelector('[data-bh-review-lightbox-date]');
    const rating = dialog.querySelector('[data-bh-review-lightbox-rating]');
    const comment = dialog.querySelector('[data-bh-review-lightbox-comment]');
    const counter = dialog.querySelector('[data-bh-review-lightbox-counter]');
    const previousButton = dialog.querySelector('[data-bh-review-lightbox-prev]');
    const nextButton = dialog.querySelector('[data-bh-review-lightbox-next]');
    dialog._bhRecords = records;
    if (!Number.isInteger(dialog._bhActiveIndex) || dialog._bhActiveIndex >= records.length) {
      dialog._bhActiveIndex = 0;
    }

    const render = (index) => {
      const currentRecords = dialog._bhRecords || [];
      if (!currentRecords.length) return;
      dialog._bhActiveIndex = (index + currentRecords.length) % currentRecords.length;
      const record = currentRecords[dialog._bhActiveIndex];
      image.src = record.source;
      image.alt = record.alt;
      author.textContent = record.author;
      date.textContent = record.date;
      rating.textContent = record.rating;
      comment.textContent = record.comment;
      counter.textContent = `${dialog._bhActiveIndex + 1} / ${currentRecords.length}`;
      const hideNavigation = currentRecords.length < 2;
      if (previousButton) previousButton.hidden = hideNavigation;
      if (nextButton) nextButton.hidden = hideNavigation;
    };

    dialog._bhRender = render;

    section._bhOpenReviewPhoto = (index) => {
      dialog._bhRender(index);
      if (!dialog.open) {
        dialog.showModal();
        document.documentElement.classList.add('bh-review-lightbox-open');
      }
    };

    if (dialog.dataset.bhBound === 'true') return;
    dialog.dataset.bhBound = 'true';
    dialog.querySelector('[data-bh-review-lightbox-close]')?.addEventListener('click', () => dialog.close());
    previousButton?.addEventListener('click', () => dialog._bhRender(dialog._bhActiveIndex - 1));
    nextButton?.addEventListener('click', () => dialog._bhRender(dialog._bhActiveIndex + 1));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if ((dialog._bhRecords || []).length < 2) return;
      if (event.key === 'ArrowLeft') dialog._bhRender(dialog._bhActiveIndex - 1);
      if (event.key === 'ArrowRight') dialog._bhRender(dialog._bhActiveIndex + 1);
    });
    dialog.addEventListener('close', () => document.documentElement.classList.remove('bh-review-lightbox-open'));
  };

  const buildReviewGallery = (section) => {
    const gallery = section.querySelector('[data-bh-review-gallery]');
    const track = section.querySelector('[data-bh-review-gallery-track]');
    const count = section.querySelector('[data-bh-review-gallery-count]');
    if (!gallery || !track) return;

    const records = mergeReviewMedia(section._bhRemoteReviewMedia || [], collectReviewMedia(section));
    setupLightbox(section, records);
    const signature = records.map((record) => record.source).join('|');
    if (track.dataset.bhSignature === signature) return;
    track.dataset.bhSignature = signature;
    track.replaceChildren();

    records.forEach((record, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bh-review-gallery__item';
      button.setAttribute('aria-label', `Abrir foto ${index + 1} de ${records.length}`);
      const image = document.createElement('img');
      image.src = record.source;
      image.alt = record.alt;
      image.loading = 'lazy';
      button.append(image);
      if (index === 0) {
        button.classList.add('is-first');
        const label = document.createElement('span');
        label.className = 'bh-review-gallery__label';
        label.textContent = gallery.querySelector('h3')?.textContent || 'Galería de reseñas';
        button.append(label);
      }
      button.addEventListener('click', () => section._bhOpenReviewPhoto?.(index));
      track.append(button);
    });

    gallery.hidden = records.length === 0;
    section.classList.toggle('has-review-gallery', records.length > 0);
    if (count) count.textContent = records.length ? `${records.length} fotos` : '';
  };

  const widgetHasRendered = (section) => {
    const widget = section.querySelector('[data-bh-reviews-widget]');
    if (!widget) return false;
    return Boolean(
      widget.querySelector('.jdgm-rev-widg, .jdgm-rev, .jdgm-form-wrapper, [data-testid="review-widget"]') ||
      normalize(widget.textContent).length > 20
    );
  };

  const refresh = (section) => {
    translateTextNodes(section);
    translateAttributes(section);
    enhanceAccessibility(section);
    buildReviewGallery(section);
    if (widgetHasRendered(section)) section.classList.add('is-ready');
  };

  const initializeSection = (section) => {
    if (section.dataset.bhReviewsInitialized === VERSION) return;
    section.dataset.bhReviewsInitialized = VERSION;
    let scheduled = false;
    const scheduleRefresh = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        refresh(section);
      });
    };
    new MutationObserver(scheduleRefresh).observe(section, { childList: true, subtree: true });
    scheduleRefresh();
    loadAllReviewMedia(section);
    window.setTimeout(() => section.classList.add('is-ready'), 3500);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-bh-product-reviews]').forEach(initializeSection);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  if (document.readyState !== 'loading') initializeAll();

  window.BHProductReviews = { version: VERSION, refresh: () => initializeAll() };
})();
